<template>
  <StateAnalysis
    title="精神评价报告"
    report="jsReportHistories"
  ></StateAnalysis>
</template>

<script>
import StateAnalysis from "./state.vue";
export default {
  components: {
    StateAnalysis,
  },
  computed: {},
  methods: {},
};
</script>

<style >
</style>